import { render, staticRenderFns } from "./CurrencyOperaciones.vue?vue&type=template&id=521e3966&scoped=true&"
import script from "./CurrencyOperaciones.vue?vue&type=script&lang=ts&"
export * from "./CurrencyOperaciones.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyOperaciones.vue?vue&type=style&index=0&id=521e3966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e3966",
  null
  
)

export default component.exports